import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useInterviewStore } from "../../../store/useInterviewStore";
import { REFINE_OPTIONS } from "../../../utils/variables";
import { deleteInterviews, fetchInterviews } from "../../../api";

import { RaffleIcon } from "../../../assets/image/RaffleIcon";
import { RebootIcon } from "../../../assets/image/RebootIcon";
import { InterviewAccept } from "../../Interview/InterviewAccept";
import { InterviewDataRow } from "./InterviewDataRow";

export const InterviewInvite = ({
                                     setProfileSection
                                   }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const slugdata = useParams();

  let data = slugdata.name;

  const [isCheck, setIsCheck] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [deleteList, setDeleteList] = useState([]);

  const {
    interview,
    setInterview,
    recived,
    setRecived,
    view,
    setView,
    refine,
    setRefine,
    resetInterviewState,
  } = useInterviewStore();

  useEffect(() => {
    return () => {
      resetInterviewState();
    };
  }, []);

  useEffect(() => {
    if (isCheck) {
      handleInterviewData();
    }
    }, []);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setRecived("text-refine");
    }
  }, []);

  const handleInterviewData = async () => {
    setInterview([]);

    try {
      const data = await fetchInterviews(refine);
      setInterview(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteInerviews = async () => {
    try {
      await deleteInterviews(deleteList);
      handleInterviewData();
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleAddCheckbox = () => {
    const ele = document.getElementsByName("chk");
    interview.map((data) => {
      deleteList.push(data.id);
    });
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = true;
    }
  };

  const handleRemoveCheckbox = () => {
    const ele = document.getElementsByName("chk");
    Array.from(ele).forEach((e) => {
      if (e.type === "checkbox") e.checked = false;
    });
    setDeleteList([]);
  };

  const hadnleDeleteSelect = (id) => {
    if (deleteList.includes(id)) {
      setDeleteList((prev) => prev.filter((item) => item !== id));
    } else {
      setDeleteList((prev) => [...prev, id]);
    }
  };

  const handleRefineDay = (e) => {
    setRefine({
      threedays: e == "3" ? true : "",
      withinweek: e == "7" ? true : "",
      twofourday: e == "24" ? true : "",
      withinmonth: e == "30" ? true : "",
    });
    setIsCheck(true);
  };

  return (
    <div>
      {view == "" ? (
        <>
          <div class="main-header">
            <h2 className="border">{t("interview-invites")}</h2>
            <div class="mail-header-bar">
              <p>
                {interview.length} {t("text-invites")}
              </p>
              <div class="btn-group flex">
                {t("text-refine")}
                <div className="select">
                  <label onClick={(e) => setIsActive(!isActive)}>
                    {t(recived)}
                    <span>
                      <img src="/images/done_a.svg" />
                    </span>
                  </label>
                  {isActive && (
                    <ul>
                      {REFINE_OPTIONS.map((option) => (
                        <li
                          key={option.label}
                          onClick={() => {
                            setRecived(t(option.label));
                            handleRefineDay(option.value);
                            setIsActive(!isActive);
                          }}
                        >
                          {t(option.label)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div class="mail-option">
              <div class="chk-all">
                <input
                  type="checkbox"
                  class="mail-radio mail-group-radio"
                  name="chk"
                  id="checkbox_id"
                  onClick={(e) => {
                    if (e.target.checked) {
                      handleAddCheckbox();
                    } else {
                      handleRemoveCheckbox();
                    }
                  }}
                />
                <span className="circle"></span>
                <label for="checkbox_id">{t("select-all")}</label>
              </div>
              <div class="right-side-btn">
                <div
                  class="delete-btn"
                  onClick={(e) => handleDeleteInerviews()}
                >
                  <a href="#">
                    <RaffleIcon />
                    <span> {t("text-delete")}</span>
                  </a>
                </div>
                <div class="refresh-btn" onClick={(e) => handleInterviewData()}>
                  <a href="#">
                    <RebootIcon />
                  </a>
                  <span>{t("text-refresh")}</span>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-inbox table-hover">
            <tbody>
              {interview.map((data) => {
                return (
                  <InterviewDataRow
                    data={data}
                    hadnleDeleteSelect={hadnleDeleteSelect}
                    slugdata={slugdata}
                    setView={setView}
                    setProfileSection={setProfileSection}
                  />
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <div class="main-header">
          <button
            onClick={(e) => {
              navigate("/search-parents/" + slugdata.id);
              setView("");
            }}
          >
            <RebootIcon />
            {t("text-back")}
          </button>
          <InterviewAccept id={view} />
        </div>
      )}
    </div>
  );
}
